// Text of the confirm popup for the Disable / Activate / Update Disable Date
// actions on the User, Common, Branch and Receivable configuration pages
export const DISABLE_CONFIRM = {
  title: "Disable",
  content: "Are you sure want to disable",
  confirmButton: "Disable",
  subContent: "Select a valid date before proceeding.",
  mode: "picker",
};

export const ACTIVATE_CONFIRM = {
  title: "Active",
  content: "Are you sure want to activate",
  confirmButton: "Activate",
  subContent:
    "This will activate the configuration and keep its original Active Date.",
  mode: null,
};

export const UPDATE_DISABLE_DATE_CONFIRM = {
  title: "Update Disable Date",
  content: "Select the new disable date",
  confirmButton: "Update Date",
  subContent:
    "The selected configurations stay inactive. Only their Disable Date changes.",
  mode: "picker",
};
